import React from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import 'typeface-roboto';
import { Workbox } from 'workbox-window';
import App from './app/app';
import { INTERCOM_CUSTOM_LAUNCHER_ID } from './app/common/intercom/intercom-store';
import { availableLanguagesToIso6291Map } from './app/common/utilFunctions/pure-utils';
import { isLocalhost } from './app/common/v2/environment/utils';
import './assets/css/font.css';
import './assets/css/global.css';
import i18n from './i18n';

// TODO: rely on the LocalStorageLanguageService instead
const languageInStorage = localStorage.getItem('i18nextLng');

let intercomSettings: Intercom_.IntercomSettings = {
  app_id: 'qcxorkyv',
  hide_default_launcher: true,
  custom_launcher_selector: `#${INTERCOM_CUSTOM_LAUNCHER_ID}`,
};

if (
  languageInStorage &&
  Object.values(availableLanguagesToIso6291Map).includes(languageInStorage)
) {
  intercomSettings = {
    ...intercomSettings,
    language_override: availableLanguagesToIso6291Map[languageInStorage],
  };
}
window.intercomSettings = intercomSettings;

if (!isLocalhost) {
  const wb = new Workbox(`/service-worker.js`);

  const isServiceWorkerSupported: () => boolean = () =>
    'serviceWorker' in navigator;

  // Track whether a SW was already controlling the page before we register.
  // On first-ever visit there's no controller, so we should NOT show the
  // "new version" prompt — it would be misleading.
  const hadController = Boolean(navigator.serviceWorker?.controller);

  // When a new service worker is waiting, tell it to activate immediately
  wb.addEventListener('waiting', () => {
    wb.messageSkipWaiting();
  });

  // When the new service worker takes control, notify the app so it can show a reload prompt
  wb.addEventListener('controlling', () => {
    if (hadController) {
      window.dispatchEvent(new CustomEvent('sw-updated'));
    }
  });

  const registerServiceWorker = (): void => {
    if (isServiceWorkerSupported()) {
      wb.register()
        .then(() => {
          console.log('Service Worker registration completed');
        })
        .catch((err) => {
          console.error('Service Worker registration failed:', err);
        });
    }
  };

  registerServiceWorker();
}

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <I18nextProvider i18n={i18n}>
    {/* <React.StrictMode> */}
    <App />
    {/* </React.StrictMode> */}
  </I18nextProvider>
);
